import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
import { Stack } from '@famly/mf_layout_stack';
import { Button } from '@famly/mf_input_button';
import { Checkbox } from '@famly/mf_input_checkbox';
import { Modal, ModalHeader, ModalTitle, ModalCloseButton, ModalContent } from '@famly/mf_modals-dialogs_modal';
import translate from 'signin-app/helpers/translate';
import * as GroupsActions from 'signin-app/groups/actions';
import * as LocalStorage from 'signin-app/api/helpers/local-storage';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import * as Actions from './actions';
import * as Selectors from './selectors';
const DisplayedGroupsSettingsModal = () => {
    const groups = useTypedSelector(Selectors.groupsForFormData);
    const initialValues = React.useMemo(() => ({ groups }), [groups]);
    const dispatch = useDispatch();
    const handleClose = React.useCallback(() => {
        dispatch(Actions.hide.action());
    }, [dispatch]);
    const handleSubmit = React.useCallback((formValues) => {
        const hiddenGroupIds = formValues.groups.filter(group => !group.value).map(group => group.id);
        LocalStorage.saveHiddenGroupIds(hiddenGroupIds);
        dispatch(GroupsActions.updateHiddenGroups.action(hiddenGroupIds));
        handleClose();
    }, [handleClose, dispatch]);
    return (_jsxs(Modal, { open: true, size: "compact", "data-e2e-id": "displayed-groups-modal", children: [_jsxs(ModalHeader, { children: [_jsx(ModalTitle, { title: translate('settings') }), _jsx(ModalCloseButton, { onClose: handleClose })] }), _jsxs(ModalContent, { children: [_jsx(Text, { variant: "body-small", mb: 1, emphasized: true, children: translate('settingsExplanation') }), _jsx(DisplayedGroupsForm, { initialValues: initialValues, onSubmit: handleSubmit })] })] }));
};
const DisplayedGroupsForm = ({ initialValues, onSubmit }) => {
    const { control, handleSubmit } = useForm({ defaultValues: initialValues });
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit(async (values) => onSubmit(values)), children: [_jsx(Stack, { direction: "column", spacing: 2, children: initialValues.groups.map((group, index) => (_jsx(Controller, { control: control, name: `groups.${index}.value`, render: ({ field }) => (_jsx(Checkbox, { checked: field.value, onChange: (_, checked) => field.onChange(checked), label: group.title, "data-e2e-id": `displayed-group-checkbox-${group.id}` })) }, group.id))) }), _jsx(Box, { position: "sticky", bottom: 0, zIndex: 3, backgroundColor: "n0", pt: 4, children: _jsx(Button, { type: "submit", variant: "primary", fullWidth: true, text: i18next.t($ => $.save), "data-e2e-id": "displayed-groups-save-button" }) })] }));
};
export default DisplayedGroupsSettingsModal;
